<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div v-if="createModel">
			<div class="mb-2 mt-2 pt-3">
				<template >
					<el-header>{{ com_info.com_no  }} - {{ com_info.title  }}</el-header>
				</template>
			</div>
			<div>
				<el-table :data="dialog_list" @sort-change="sortChange" border style="width: 100%">
					
					<el-table-column type="expand" label="參加學校" width="120" align="center">
									<!-- 使用作用域插槽访问當前行數据 -->
									<template slot-scope="scope">
										<!-- 绑定内嵌表格數据到當前行的topList属性 -->
										<el-table :data="scope.row.schoolList" border style="width: 100%">
											<el-table-column align="center" prop="school_name" label="名稱"></el-table-column>
											<el-table-column align="center" prop="registration_count" label="報名人數"></el-table-column>
											<el-table-column align="center" prop="competition_count" label="比賽人數"></el-table-column>
											<el-table-column prop="id" align="center" width="120" label="操作">
												<template slot-scope="school">
													<el-button-group>
													<el-button
														size="mini"
														plain
														type="primary"
														@click="getStudent(scope.row.id,school.row.school_id)"
														>學生詳情</el-button
													>
												
													</el-button-group>
												</template>
											</el-table-column>
											
										</el-table>
									</template>
					</el-table-column>

					<el-table-column
						align="center"
						prop="name"
						label="組别名稱"
						></el-table-column>

						<el-table-column
						align="center"
						prop="total_score"
						label="試卷總分"
						></el-table-column>

						<el-table-column
						align="center"
						prop="participant_count"
						label="比賽人數"
						></el-table-column>

						<el-table-column
						align="center"
						prop="check_count"
						label="未改試卷"
						></el-table-column>

						<el-table-column
						align="center"
						prop="time"
						label="时長限制"
						></el-table-column>
						<el-table-column prop="id" align="center" width="140" label="操作">
												<template slot-scope="scope">
													<el-button-group>
													<el-button
														size="mini"
														plain
														type="warning"
														@click="setRobot(scope.row.id)"
														>添加機器人</el-button
													>
													</el-button-group>
												</template>
											</el-table-column>
						
				</el-table>
			</div>

			<div class="mb-2 mt-2 pt-3">
				<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				

					<!-- 高級搜索 1-->
					<template #from>
						<el-form inline ref="form" :model="from" label-width="100px">
							<el-form-item label="標題" class="mb-0">
								<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
							</el-form-item>

							<el-form-item label="比賽編號" class="mb-0">
								<el-input size="small" v-model="from.com_no" placeholder="比賽編號"></el-input>
							</el-form-item>
							
							<el-form-item label="是否收費" class="mb-0">
								<el-select v-model="from.pay_type" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="免費" value="1"></el-option>
									<el-option label="收費" value="2"></el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="比賽人選" class="mb-0">
								<el-select v-model="from.is_school" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="無限制" value="0"></el-option>
									<el-option label="非學校用戶" value="1"></el-option>
									<el-option label="學校用戶" value="2"></el-option>
								</el-select>
							</el-form-item>
							
							<el-form-item label="發送時間" size="small" class="mb-0">
								<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
								range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>

							<el-form-item class="mb-0">
								<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
								<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
							</el-form-item>

						</el-form>
					</template>
				</button-search>
			</div>

			<div class="mt-3 pt-2">
				<el-table :data="dialog_suer_list" border style="width: 100%" >
						
					<el-table-column align="center" prop="join_no" label="預約編號">
					</el-table-column>
						
					<el-table-column align="center" prop="topic_no" label="做題編號">
					</el-table-column>

					<el-table-column align="center" prop="name" label="學生名稱">
					</el-table-column>
					
					<el-table-column align="center" prop="email" label="學生郵箱">
					</el-table-column>

					<el-table-column align="center" prop="score" label="成績">
					</el-table-column>

					<el-table-column align="center" prop="yes_num" label="答对數量">
					</el-table-column>

					<el-table-column align="center" prop="use_time_text" label="做題时長">
					</el-table-column>

					<el-table-column align="center" prop="is_robot" label="類型">
						<template slot-scope="v">
							<span class="text-success" v-if="v.row.is_robot==0">學生</span>
							<span class="text-warning" v-if="v.row.status==1">機器人</span>
						</template>
					</el-table-column>
					
				
				</el-table>
			</div>

			<div style="height: 60px;"></div>
			<!-- <el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			
				<div style="flex: 1;" class="px-2">
					<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
					</el-pagination>
				</div>
			</el-footer> -->

			<el-dialog :close-on-click-modal="false"  title="添加機器人" :visible.sync="createRobotModel" 
			top="5vh" :width="layout.is_phone?'90%':'60%'">
				<!-- 表單内容 -->
				<el-form  :rules="rules" ref="formEdit" :model="formRobot" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
					<el-form-item label="機器人數量" >
						<span>{{robotNum}}</span>
					</el-form-item>
					

					<el-form-item label="機器人數量" prop="num">
						<el-input type="number" v-model="formRobot.num" 
						placeholder="機器人數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
				</el-form>

				<div slot="footer" class="dialog-footer">
					<el-button @click="createRobotModel = false">取 消</el-button>
					<el-button type="primary" @click="submitRobot">確 定</el-button>
				</div>
			</el-dialog>
		</div>

		
		<div v-else>

			<div class="mb-2 mt-2 pt-3">
				<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
					<!-- 高級搜索 1-->
					<template #from>
						<el-form inline ref="form" :model="from" label-width="100px">
							<el-form-item label="標題" class="mb-0">
								<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
							</el-form-item>

							<el-form-item label="比賽編號" class="mb-0">
								<el-input size="small" v-model="from.com_no" placeholder="比賽編號"></el-input>
							</el-form-item>
							
							<el-form-item label="是否收費" class="mb-0">
								<el-select v-model="from.pay_type" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="免費" value="1"></el-option>
									<el-option label="收費" value="2"></el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="比賽人選" class="mb-0">
								<el-select v-model="from.is_school" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="無限制" value="0"></el-option>
									<el-option label="非學校用戶" value="1"></el-option>
									<el-option label="學校用戶" value="2"></el-option>
								</el-select>
							</el-form-item>
							
							<el-form-item label="發送時間" size="small" class="mb-0">
								<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
								range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>

							<el-form-item class="mb-0">
								<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
								<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
							</el-form-item>

						</el-form>
					</template>
				</button-search>
			</div>

			<!-- 表格 -->
			<div class="mt-3 pt-2">
				<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
					
					<el-table-column align="center" prop="com_no" label="比賽編號">
					</el-table-column>
						
					<el-table-column align="center" prop="title" label="比賽">
					</el-table-column>

					<el-table-column align="center" prop="subject_name" label="學科">
					</el-table-column>
					
					
					<el-table-column align="center" prop="status" label="顯示狀態" >
						<template slot-scope="scope">
							<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row)"
							plain>{{scope.row.status ? '顯示' : '隱藏'}}
							</el-button>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="pay_type" label="費用">
						<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.pay_type==1">免費</span>
								<span v-if="v.row.pay_type==2"><i class="text-success" >學校用戶</i>-{{v.row.money}} <br> <i class="text-primary" >非學校用戶</i>-{{v.row.no_school_money}}</span>
							</template>
					</el-table-column>				
					
					<el-table-column align="center" prop="ins_name" label="機構名稱">
					</el-table-column>
					
					<el-table-column align="center" prop="total_user" label="報名人數">
					</el-table-column>

					<el-table-column align="center" prop="prize_end_status" label="訂購狀態">
						<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.prize_end_status==0">未開始</span>
								<span class="text-success" v-if="v.row.prize_end_status==1">進行中</span>
								<span class="text-success" v-if="v.row.prize_end_status==2">已結束</span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="apply_status" label="報名進度">
							<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.apply_status==0">未開始</span>
								<span class="text-success" v-if="v.row.apply_status==1">進行中</span>
								<span class="text-danger" v-if="v.row.apply_status==2">已結束</span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="start_status" label="比賽進度">
							<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.start_status==0">未開始</span>
								<span class="text-success" v-if="v.row.start_status==1">進行中</span>
								<span class="text-danger" v-if="v.row.start_status==2">已結束</span>
								<span class="text-danger" v-if="v.row.start_status==3">公佈結果</span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="audit_status" label="公佈狀態">
							<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.audit_status==0">未提交</span>
								<span class="text-success" v-if="v.row.apply_status==1">待審核</span>
								<span class="text-danger" v-if="v.row.apply_status==2">完成</span>
								<span class="text-danger" v-if="v.row.apply_status==3">駁回</span>
							</template>
					</el-table-column>

					<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row.id)">查看詳情</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div style="height: 60px;"></div>
			<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
				<!-- 底部 -->

				<div style="flex: 1;" class="px-2">
					<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
					</el-pagination>
				</div>
			</el-footer>
		</div>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				createRobotModel: false,
				editIndex: -1,
				type:1,
				com_id: null,
				//搜索數据

				rules: {
					
					num: [
						{
						required: true,
						message: "機器人數量不能為空",
						trigger: 'blur',
						},
						{
						validator: (rule, value, callback) => {
							if (value <= 0) {
							callback(new Error("機器人數量不能小於或等於 0"));
							} else if (value > this.robotNum) {
							callback(new Error(`機器人數量不能大於 ${this.robotNum}`));
							} else {
							callback();
							}
						},
						trigger: 'blur'
						}
					],
				},
				robotNum: 0,

				from: {
					title: '',
					com_no: '',
					pay_type:'-1',
					is_school:'-1',
					time: [],
				},
				formRobot:{
					num:0,
				},
				model_title: 'getCom',
				auth_val: 'data/getComInfo',
				preUrl: "data/getComList", //列表地址
				delAllUrl: "data/delUserEmailAll", //批量删除地址
				delUrl: "data/delUserEmail", //删除單条地址
                editStatusUrl: "data/editStatusUserEmail", //修改狀態地址

				tableData: [],
				
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
                dialog_list:[],
                com_info:[],
				dialog_suer_list:[],

				
			}
		},
		created() {
			this.commonList(['subject_list','grade_list']);
		},
		methods: {
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
			},
			setRobot(id){
				this.formRobot ={
					num:0,
					id:id,
				},
				// this.layout.loading = true;
				this.axios.post('/admin/data/getRobotNum', this.formRobot, {
					token: true,
				}).then(res => {
					// 打开dialog
					this.robotNum = res.data.data.robotNum;
					this.createRobotModel = true;
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
				// this.layout.loading = true;
				
			},
			submitRobot(){
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.layout.loading = true;
						this.axios.post('/admin/data/setRobot', this.formRobot, {
							token: true,
						}).then(resg => {
							// 打开dialog
							this.getComInfo()
							this.createRobotModel = false;
							this.layout.loading = false;
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
						})
					}
				})
				
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.grade_list = list.grade
					this.subject_list = list.subject

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
		
		
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			},
			//獲取學生詳情
			getStudent(com_id,school_id){
				this.layout.loading = true;
				this.axios.post('/admin/data/getUserComList', {
					id: com_id,
					school_id:school_id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.dialog_suer_list = list.list
					// 打开dialog
				
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
		
			// 打开模态框
			openModel(e) {
				this.com_id = e;
				this.createModel = true;
				this.getComInfo()
			},

			getComInfo(){
				this.axios.post('/admin/data/getComInfo', {
					id: this.com_id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.dialog_list = list.list
					this.com_info = list.com_info
					
				}).catch(err => {
					
				})
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
                clearSearch() {
				this.from = {
                    title: '',
					com_no: '',
					pay_type:'-1',
					is_school:'-1',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>


<style>
</style>



